import styled from 'styled-components';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
//
import colors from 'theme/colors';
import InfoIcon from 'components/icons/info';

const { darkInputBorder, disabledButton, globalIcon, lightBorder, platinum60, primary } = colors;

export const ProductItemsContainer = styled.div``;

export const Table = styled.table`
  width: 100%;
  font-size: 14px;
  border-collapse: collapse;
  text-align: right;
  table-layout: fixed;
`;

export const TableHeader = styled.thead``;

export const TableHeaderCell = styled.td`
  padding: 2px 20px;
  font-size: 12px;
  width: auto;
`;

export const TableHeaderRow = styled.tr`
  border-bottom: 1px solid ${lightBorder};
  font-weight: 600;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${lightBorder};
`;

export const TableCell = styled.td`
  padding: 12px 20px;
  word-break: break-all;
`;

export const NoProductCell = styled(TableCell)`
  padding: 18px;
  text-align: center;
`;

export const TableEndCell = styled.td`
  width: 32px;
  padding-right: 8px;
`;

export const TableExpansionRow = styled.tr`
  background-color: ${platinum60};
`;

export const TableExpansionCell = styled(TableCell)``;

export const ProductCell = styled(TableCell)`
  width: 30%;
`;

export const ExpandMoreIcon = styled(ExpandMore)`
  color: ${globalIcon};
  :hover {
    cursor: pointer;
  }
`;

export const ExpandLessIcon = styled(ExpandLess)`
  color: ${globalIcon};
  :hover {
    cursor: pointer;
  }
`;

export const DownloadDetailsCell = styled.td`
  padding-right: 30px;
  padding-bottom: 8px;
`;

export const DownloadDetailsButton = styled.button`
  background: none;
  border: none;
  color: ${primary};
  opacity: 1;
  transition: opacity 0.2s ease;

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }

  div {
    font-size: 10px;
    position: relative;
    top: -2px;
  }
`;

export const Container = styled.div`
  margin-bottom: 8px;
`;

export const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: ${platinum60};
  border: 1px solid ${disabledButton};
  font-size: 16px;
  font-weight: 600;
`;

export const ProductName = styled.div`
  width: 140px;
  text-align: left;
`;

export const ExpansionButton = styled.div`
  width: 40px;
  text-align: center;
`;

export const DateRange = styled.span`
  font-size: 14px;
  font-weight: 400;
  width: 140px;
`;

export const StackedField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 140px;

  span:nth-of-type(2) {
    font-size: 12px;
    font-weight: 400;
    color: ${darkInputBorder};
  }
`;

export const Bottom = styled.div`
  margin: 16px;
`;

export const BottomTop = styled.div`
  margin-bottom: 48px;
`;

export const FormulaTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th {
    font-weight: 600;
  }

  th:not(:first-of-type) {
    border-bottom: 1px solid ${lightBorder};
  }

  th,
  td {
    font-size: 14px;
    padding: 8px;
    text-align: center;
  }

  /* first column */
  tr > td:first-of-type {
    font-weight: 600;
    padding-right: 16px;
    text-align: left;
    width: 200px;
  }

  /* second column */
  th:nth-of-type(2),
  td:nth-of-type(2) {
    text-align: left;
  }

  /* third column */
  th:nth-of-type(3),
  td:nth-of-type(3) {
    text-align: right;
  }

  /* fourth column */
  th:nth-of-type(4),
  td:nth-of-type(4) {
    text-align: right;
  }

  /* last column */
  th:last-of-type,
  td:last-of-type {
    text-align: right;
  }

  /* last row */
  tr:last-of-type > td:not(:first-of-type) {
    border-bottom: 1px solid ${lightBorder};
  }
`;

export const OptionTable = styled.table`
  border: 1px solid ${lightBorder};
  border-collapse: collapse;

  td,
  th {
    font-size: 12px;
    font-weight: 400;
    padding: 0px 16px;
    height: 45px;
    text-align: center;
  }

  th {
    border-bottom: 1px solid ${lightBorder};
  }
`;

export const FormulaIcon = styled.span`
  color: lightblue;
  margin-right: 8px;
`;

export const BottomBottom = styled.div`
  display: flex;
  justify-content: space-between;

  ${OptionTable}:first-of-type {
    flex: 5;
    margin-right: 16px;
  }

  ${OptionTable}:last-of-type {
    flex: 1;
  }
`;

export const StyledInfoIcon = styled(InfoIcon)`
  width: 0.75em !important;
`;

export const OptionValueTableHeader = styled.th`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChartedContainer = styled.div`
  position: relative;
  top: -48px;
`;

export const ProductItemHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
`;

export const ProductItemHeaderLeft = styled.div`
  /* display: flex; */
`;

export const ProductItemChartedHeader = styled.div`
  margin: 16px 0px;
  display: flex;
  justify-content: space-between;

  > div:first-of-type {
    display: flex;

    > div {
      margin-right: 16px;
    }
  }
`;

export const ProductItemHeaderRight = styled.div``;

export const VisualToggleContainer = styled.div`
  display: flex;

  & > * {
    margin-left: 8px;
  }
`;
